export const QuestionData = [
  {
    id: 1,
    title:
      "오랜만에 친구와 놀던 중 친구의 친구가 같이 놀아도 되냐고 물어보는데?",
    answera: "새로운 사람 언제든 웰컴",
    answerb: "아니..(불편해)",
    type: "EI",
  },
  {
    id: 2,
    title: "다음 중 더 공감되는 말은",
    answera: "평일에 하루종일 학교에만 있었으니까 주말에 나가야지",
    answerb: "평일에 하루종일 학교에만 있었으니까 주말에는 집에 있어야지",
    type: "EI",
  },
  {
    id: 3,
    title: "친구들과 대화할 때 나는 주로",
    answera: "말을 하는 편",
    answerb: "애기를 듣는 편",
    type: "EI",
  },
  {
    id: 4,
    title: "비행기를 탔는데 갑자기 흔들린다면?",
    answera: "어라 비행기 흔들린다 무섭다 멀미난다.",
    answerb:
      "낙하산을 타고 비행기를 탈출하면 바다에 빠지게 되겠지.. 나 수영 못하는데...",
    type: "SN",
  },
  {
    id: 5,
    title: "아무 생각도 안해",
    answera: "정말 아무 생각도 안한다.",
    answerb: "아무생각도 하지 않는 것을 생각한다.",
    type: "SN",
  },
  {
    id: 6,
    title: '"병아리는 멍멍 참새는 어흥"을 외우라고 한다면?',
    answera: "이해가 안가는데 뭐 맞는 말이니까 가르치는거겠지. 일단 외우자",
    answerb:
      "이해가 안가는데? 내 지식으로는 성립이 안되는데? 이해를 못하겠는데 어떻게 외워",
    type: "SN",
  },
  {
    id: 7,
    title: "나 차 사고 났어..",
    answera: "보험은 들었어? 사고 보장은 돼?",
    answerb: "진짜? 다친 데는 없고? 괜찮아?”",
    type: "TF",
  },
  {
    id: 8,
    title: "사람들이 너 싫어해!",
    answera: "어쩌라는 거지? 싫어하든 말든, 내 탓이야?",
    answerb: "왜 날 싫어하지..? 내가 뭘 잘못했나..? 슬프다..",
    type: "TF",
  },
  {
    id: 9,
    title: "정말 잘한 것 같아! 너 열심히 안 한 것 같은데? 진짜 재능 있구나!",
    answera: "맞아. 역시 난 재능있어",
    answerb: "누가 열심히 안했데...",
    type: "TF",
  },
  {
    id: 10,
    title: "여행가기 전 나는",
    answera: " 1시까지 도착하면 2시까지 밥을 먹고 3시엔 여기로 이동해야겠다.",
    answerb: "교통이랑 숙소 정했으면 다 정했지 뭐",
    type: "JP",
  },
  {
    id: 11,
    title: "내일은 친구와 약속이 있는 날",
    answera: "내일은 이 옷을 입고 이 가방을 들고 가야지",
    answerb: " 내일 끌리는 걸로 입는다",
    type: "JP",
  },
  {
    id: 12,
    title: "나의 핸드폰 앱들은",
    answera: "용도별로 폴더화해서 잘 정리해둠",
    answerb: "그냥 다운 받아진 그대로",
    type: "JP",
  },
];
